import { isActiveSub, UserSubStatus } from 'lib/client/360-subscriptions'

import { isLoggedIn, Self } from './self'

export default function canViewContent(self: Self, userSubStatus: UserSubStatus) {
  return isLoggedIn(self) && isActiveSub(userSubStatus)
}
